var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"470px","height":"452px","viewBox":"0 0 4700 4520","preserveAspectRatio":"xMidYMid meet"}},[_c('g',{attrs:{"id":"layer1","fill":_vm.color || '#fff',"stroke":"none"}},[_c('path',{attrs:{"d":"M275 4268 c-3 -7 -4 -897 -3 -1978 l3 -1965 2080 0 2080 0 0 1975 0 1975 -2078 3 c-1657 2 -2079 0 -2082 -10z"}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99233c24","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V2/svg/components/Square.vue
// module id = 4hO7
// module chunks = 0